<div class="tree-project">
  <div class="tree-project-row" [class.is-active]="project().isActive">
    <button
      type="button"
      class="tree-toggle"
      (click)="toggleProject.emit(project().id)"
      [attr.aria-label]="'Expandir ' + project().name"
    >
      <lucide-icon [name]="expanded() ? 'chevron-down' : 'chevron-right'" class="h-4 w-4"></lucide-icon>
    </button>

    <a [routerLink]="[project().route]" class="tree-project-link" [attr.title]="project().name">
      @if (project().coverImageUrl) {
        <img [src]="project().coverImageUrl" [alt]="project().name" class="tree-project-cover" />
      } @else if (project().iconKey) {
        <span
          class="tree-project-fallback tree-project-fallback--icon"
          [style.background]="glyphColor()"
          [style.color]="glyphForeground()"
        >
          <lucide-icon [name]="project().iconKey!" class="tree-project-icon"></lucide-icon>
        </span>
      } @else {
        <span
          class="tree-project-fallback"
          [style.background]="glyphColor()"
          [style.color]="glyphForeground()"
        >{{ project().initials }}</span>
      }
      <span class="tree-project-name">{{ project().name }}</span>
    </a>

    <div class="tree-project-actions">
      <button
        type="button"
        class="tree-project-add-btn"
        (click)="createWorkflow.emit(project())"
        [attr.aria-label]="'Adicionar workflow em ' + project().name"
        [attr.title]="'Adicionar workflow em ' + project().name"
      >
        <lucide-icon name="plus" class="h-4 w-4"></lucide-icon>
      </button>
    </div>
  </div>

  @if (expanded()) {
    <div class="tree-workflows">
      @for (workflow of project().workflows; track workflow.id) {
        <app-sidebar-workflow
          [id]="workflow.id"
          [name]="workflow.name"
          [route]="workflow.route"
          [icon]="workflow.icon"
          [colorHex]="workflow.colorHex"
          [isActive]="workflow.isActive"
        ></app-sidebar-workflow>
      }
    </div>
  }
</div>
